import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type TripHistoryViewMode = 'desktop' | 'mobile';

export interface TripHistoryModeConfig {
  autoSelectFirstTrip: boolean;
  mobileLayout: boolean;
}

export const getTripHistoryModeConfig = (mode: TripHistoryViewMode): TripHistoryModeConfig => {
  if (mode === 'mobile') {
    return {
      autoSelectFirstTrip: false,
      mobileLayout: true,
    };
  }

  return {
    autoSelectFirstTrip: true,
    mobileLayout: false,
  };
};

// Centralized mode resolver so orchestrators and tests share one breakpoint decision.
export const useTripHistoryViewMode = (): TripHistoryViewMode => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return isMobile ? 'mobile' : 'desktop';
};
